(() => {
  if (typeof HTMLDialogElement === 'undefined') return;

  let activeTrigger = null;

  const getGateway = () => {
    const gateway = document.querySelector('[data-h7-account-gateway]');
    return gateway instanceof HTMLDialogElement ? gateway : null;
  };

  // Bound lazily so a header re-render (theme editor section reload) swaps in
  // a fresh dialog without leaving the gateway inert or double-bound.
  const bindGateway = (gateway) => {
    if (gateway.dataset.h7GatewayBound === 'true') return;
    gateway.dataset.h7GatewayBound = 'true';

    gateway.addEventListener('click', (event) => {
      if (event.target === gateway) gateway.close();
    });

    gateway.addEventListener('close', () => {
      document.documentElement.classList.remove('h7-account-gateway-open');
      window.H7OverlayCoordinator?.release('h7-account-gateway');
      activeTrigger?.focus();
      activeTrigger = null;
    });
  };

  const openGateway = async (trigger) => {
    const gateway = getGateway();
    if (!gateway || gateway.open) return;
    await window.H7OverlayCoordinator?.request('h7-account-gateway', { priority: 30 });
    const current = getGateway();
    if (!current || current.open) {
      // Releasing here matters: returning while still holding the coordinator
      // lock froze every other overlay (currency prompt, scratch card) for
      // the rest of the page view.
      window.H7OverlayCoordinator?.release('h7-account-gateway');
      return;
    }
    bindGateway(current);
    activeTrigger = trigger;
    current.showModal();
    document.documentElement.classList.add('h7-account-gateway-open');
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-h7-account-trigger]');
    if (trigger) openGateway(trigger);
  });
})();
